import styled from '@emotion/styled'
import { Flex } from 'components'
import { theme } from 'styles/theme/hav-theme'

export const Title = styled.span`
  font-size: ${theme.typography.sizes.sm};
  color: ${theme.colors.neutral.black};
  font-weight: ${theme.typography.weight.md};
`

export const Form = styled('form')`
  width: 100%;
`

export const Container = styled.div`
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.xm};
  border-radius: ${theme.shapes.borderRadius.xm};
  border: 1px solid ${theme.colors.neutral.softer};
`

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  padding: ${theme.spacing.xm};
  background-color: ${theme.colors.neutral.white};
  gap: ${theme.spacing.xs};
`

export const TabsWrapper = styled.div`
  width: 100%;

  #action-tabs-wrap {
    margin: 0;
    padding: 0;

    button {
      font-size: ${theme.typography.sizes.xs};
      padding: ${theme.spacing.sm};
      font-family: ${theme.typography.family.primary};
      font-weight: ${theme.typography.weight.sm};
    }
  }
`

export const OfficeTabsWrapper = styled(TabsWrapper)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.clear};

  #action-tabs-wrap {
    border-bottom: none;
  }
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
`

export const GridContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(24, 1fr);
  gap: ${theme.spacing.sm};
`
export const GridContainerBMU = styled(GridContainer)`
  .grid-1-4 {
    grid-column: 1 / 4;
  }

  .grid-4-7 {
    grid-column: 4 / 7;
  }

  .grid-7-10 {
    grid-column: 7 / 10;
  }

  .grid-10-16 {
    grid-column: 10 / 16;
  }

  .grid-16-22 {
    grid-column: 16 / 22;
  }

  .grid-22-24 {
    grid-column: 22 / 24;
  }

  .grid-24-25 {
    grid-column: 24 / 25;
  }
`

export const GridContainerOffice = styled(GridContainer)`
  // First row
  .grid-1-4 {
    grid-column: 1 / 4;
  }

  .grid-4-7 {
    grid-column: 4 / 7;
  }

  .grid-7-10 {
    grid-column: 7 / 10;
  }

  .grid-10-13 {
    grid-column: 10 / 13;
  }

  .grid-13-19 {
    grid-column: 13 / 19;
  }

  .grid-19-25 {
    grid-column: 19 / 25;
  }

  // Second row
  .grid-1-13 {
    grid-column: 1 / 13;
  }

  .grid-13-22 {
    grid-column: 13 / 22;
  }

  .grid-22-24 {
    grid-column: 22 / 24;
  }

  .grid-24-25 {
    grid-column: 24 / 25;
  }
`

export const TableWrapper = styled.div`
  display: grid;
  width: 100%;
  overflow-x: auto;
  gap: ${theme.spacing.xm};
`

export const FileInput = styled.input`
  display: none;
`

export const CalendarInfoContainer = styled(Flex)`
border-radius: ${theme.shapes.borderRadius.xm};
background-color: ${theme.colors.ion.info.softer};
padding: ${theme.spacing.ion.medium};
`

export const IconContainer = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.shapes.borderRadius.full};
  background-color: ${theme.colors.ion.info.soft};
`

export const LinkWrapper = styled.div`
cursor: pointer;
`
